import React from 'react';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Progress } from '@/components/ui/progress';
import { Trophy, Clock, Target } from 'lucide-react';

interface Challenge {
  id: string;
  title: string;
  description: string;
  progress: number;
  difficulty: 'easy' | 'medium' | 'hard';
  reward: number;
  timeLeft: string;
}

export function ChallengesPanel() {
  const challenges: Challenge[] = [
    {
      id: '1',
      title: 'Complete Your Profile',
      description: 'Add all required information to your profile',
      progress: 75,
      difficulty: 'easy',
      reward: 50,
      timeLeft: '2 days'
    },
    {
      id: '2',
      title: 'First Project Submission',
      description: 'Submit your first project for review',
      progress: 30,
      difficulty: 'medium',
      reward: 100,
      timeLeft: '5 days'
    }
  ];

  return (
    <Card className="p-6">
      <h2 className="text-xl font-semibold mb-4">Active Challenges</h2>
      <div className="space-y-4">
        {challenges.map((challenge) => (
          <div 
            key={challenge.id}
            className="p-4 rounded-lg bg-slate-800/50 space-y-3"
          >
            <div className="flex items-start justify-between">
              <div>
                <div className="flex items-center gap-2">
                  <h3 className="font-medium">{challenge.title}</h3>
                  <Badge variant="outline">{challenge.difficulty}</Badge>
                </div>
                <p className="text-sm text-slate-400 mt-1">{challenge.description}</p>
              </div>
              <div className="flex items-center text-yellow-500">
                <Trophy className="w-4 h-4 mr-1" />
                <span className="text-sm">{challenge.reward}</span>
              </div>
            </div>
            <div className="space-y-2">
              <div className="flex justify-between text-sm text-slate-400">
                <div className="flex items-center gap-1">
                  <Clock className="w-4 h-4" />
                  <span>{challenge.timeLeft} left</span>
                </div>
                <span>{challenge.progress}% complete</span>
              </div>
              <Progress value={challenge.progress} className="h-2" />
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
} 